import { render } from "./ViewTourCollectionSelection.vue?vue&type=template&id=25f439e6&scoped=true"
import script from "./ViewTourCollectionSelection.vue?vue&type=script&lang=ts"
export * from "./ViewTourCollectionSelection.vue?vue&type=script&lang=ts"

import "./ViewTourCollectionSelection.vue?vue&type=style&index=0&id=25f439e6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-25f439e6"

export default script